export const interviewData = [
	{
		image: 'natalya-bytsko.png',
		name: 'Наталья Быцко',
		text: 'Всё решаемо. Просто нужно оценить, под каким углом смотреть',
		href: 'https://journal.credit.club/natalya-bytsko',
	},
	{
		image: 'stanislav-kutepov.png',
		name: 'Станислав Кутепов',
		text: 'Относитесь к клиенту так, как бы вы хотели, чтобы относились к вам. Это главный принцип успеха',
		href: 'https://journal.credit.club/stanislav-kutepov',
	},
	{
		image: 'lyudmila-danilova.png',
		name: 'Людмила Данилова',
		text: 'Не хочу просто перекладывать бумажки',
		href: 'https://journal.credit.club/lyudmila-danilova',
	},

	{
		image: 'viktor-suhanov.png',
		name: 'Виктор Суханов',
		text: 'С предпринимателями комфортно работать, но есть и свои минусы',
		href: 'https://journal.credit.club/viktor-suhanov',
	},
]
